import styled from 'styled-components';
import { StyledSectionItem } from '../SectionItem/styled';

export const StyledSectionName = styled(StyledSectionItem).attrs((p) => ({
  as: p.isSecondLevel ? 'h2' : 'h1',
}))`
  font-weight: 500;
`;
